module.exports = __webpack_public_path__ + "img/histortReport3.e403e97c.png";